



















































































































































































































































































































































































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { Search } from '@/data/models/search.model';
import { ClassType } from 'class-transformer/ClassTransformer';
import store, { State } from '@/store';
import { Offer } from '@/data/models/offer.model';
import { Contatto, ContattoStatus } from '@/data/models/contatto.model';
import { Comune } from '@/data/models/comune.model';
import { Provincia } from '@/data/models/provincia.model';
import { OfferService } from '@/data/services/offer.service';
import { currencyToNumber, numberMask } from '@/data/utils/helper';
import { User, UserStatus, UserType } from '@/data/models/user.model';
import { CrudService } from '@/data/services/crud.service';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class AddRiscossione extends Vue {
	@Inject('OfferService') offerService!: OfferService;
	@Inject('CrudService') crudService!: CrudService<Offer>;
	@Prop() offerId!: number;

	contactClass: ClassType<Contatto> = Contatto;
	contactSearch: Search = new Search('contact');
	contatto: Contatto | null = null;

	operatorClass: ClassType<User> = User;
	operatorSearch: Search = new Search('user');
	operator: User | null = null;

	provinciaClass: ClassType<Provincia> = Provincia;
	comuneClass: ClassType<Comune> = Comune;
	comuneSearch: Search = new Search('comuni');
	provincia: Provincia | null = null;
	comune: Comune | null = null;

	currencies: any = {};
	state!: State;
	offer: Offer = new Offer();

	numberMask: any = numberMask();

	skipContactInit: boolean = false;

	constructor() {
		super();
		this.state = store;
		this.offer.hqid = this.state.headquarter!.id;
		this.contactSearch.addSimpleFilter('hqid', this.state.headquarter!.id);
		this.contactSearch.addSimpleFilter('status', ContattoStatus.ACTIVE);
		this.operatorSearch.addSimpleFilter('hqid', this.state.headquarter!.id);
		this.operatorSearch.addSimpleFilter('utype', UserType.CALL_CENTER);
		this.operatorSearch.addNotEqualFilter('status', UserStatus.INACTIVE);
	}

	beforeMount() {
		if(this.offerId) {
			this.skipContactInit = true;
			this.loadOffer();
		}
	}

	loadOffer() {
		this.crudService.getEntity(Offer, 'offer', this.offerId).then((offer) => {
			this.offer = offer;
			this.initFromOffer();
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

	initFromOffer() {

		if(this.offer.contact) {
			this.contatto = this.offer.contact;
		}
		if(this.offer.comune) {
			this.comune = new Comune();
			this.comune.descrizione = this.offer.comune;
		}
		if(this.offer.province) {
			this.provincia = new Provincia();
			this.provincia.descrizione = this.offer.province;
		}
		if(this.offer.user) {
			this.operator = this.offer.user;
		}
	}

	onProvinciaChange() {
		if (this.provincia) {
			this.offer.province = this.provincia.descrizione;
			this.offer.comune = '';
			this.comuneSearch.addSimpleFilter('provincia', this.provincia.descrizione as string);
		}
	}

	onComuneChange() {
		if (this.comune) this.offer.comune = this.comune.descrizione;
	}

	onCurrencyChange(event: any, field: string) {
		this.currencies[field] = currencyToNumber(event.target._vCleave.getFormattedValue());
	}

	onContattoChange() {
		if (this.contatto && !this.skipContactInit) {
			this.offer.email = this.contatto.email;
			this.offer.address = this.contatto.address;
			this.offer.streetno = this.contatto.streetno;
			this.provincia = new Provincia();
			this.provincia.descrizione = this.contatto.province;
			this.onProvinciaChange();
			this.comune = new Comune();
			this.comune.descrizione = this.contatto.comune;
			this.onComuneChange();
			this.offer.city = this.contatto.city;
			this.offer.zipcode = this.contatto.zipcode;
		}
		this.skipContactInit = false;
	}

	submit() {
		Object.keys(this.currencies).forEach(k => {
			this.$set(this.offer, k, this.currencies[k]);
		});
		if(this.contatto) this.offer.contactid = this.contatto.id;
		if (this.operator) this.offer.operatorid = this.operator.id;

		this.offerService.estemporanea(this.offer).then(() => {
			this.$emit('submit', this.offer);
			this.$buefy.notification.open({
				message:  this.$t('offer-saved').toString(),
				type: 'is-success',
			});
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

	close() {
		(this.$parent as any).close();
	}

	contactFormatter = (contact: Contatto) => {
		if (contact.id) {
			return `${contact.fullname} - ${contact.landline ? contact.landline : contact.mobile}`;
		}
		
	}

}
